import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  syncPeriodEnd(event) {
    const startDate = new Date(event.target.value)
    if (isNaN(startDate)) return

    const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
    const endField = this.element.querySelector("[name*='period_end']")
    if (endField) {
      endField.value = endDate.toISOString().split("T")[0]
    }
  }
}
